import Photo1Image from '../../assets/img/evolution/photo-1.jpg';
import Photo1ImageAVIF from '../../assets/img/evolution/photo-1.avif';
import Photo1ImageWEBP from '../../assets/img/evolution/photo-1.webp';
import Photo2Image from '../../assets/img/evolution/photo-2.jpg';
import Photo2ImageAVIF from '../../assets/img/evolution/photo-2.avif';
import Photo2ImageWEBP from '../../assets/img/evolution/photo-2.webp';
import Photo3Image from '../../assets/img/evolution/photo-3.jpg';
import Photo3ImageAVIF from '../../assets/img/evolution/photo-3.avif';
import Photo4Image from '../../assets/img/evolution/photo-4.jpg';
import Photo4ImageAVIF from '../../assets/img/evolution/photo-4.avif';
import Photo4ImageWEBP from '../../assets/img/evolution/photo-4.webp';
import Photo5Image from '../../assets/img/evolution/photo-5.jpg';
import Photo5ImageAVIF from '../../assets/img/evolution/photo-5.avif';
import Photo6Image from '../../assets/img/evolution/photo-6.jpg';
import Photo6ImageAVIF from '../../assets/img/evolution/photo-6.avif';
import Photo7Image from '../../assets/img/evolution/photo-7.jpg';
import Photo7ImageAVIF from '../../assets/img/evolution/photo-7.avif';
import Photo7ImageWEBP from '../../assets/img/evolution/photo-7.webp';
import Photo8Image from '../../assets/img/evolution/photo-8.jpg';
import Photo8ImageAVIF from '../../assets/img/evolution/photo-8.avif';
import Photo8ImageWEBP from '../../assets/img/evolution/photo-8.webp';
import Photo9Image from '../../assets/img/evolution/photo-9.jpg';
import Photo9ImageAVIF from '../../assets/img/evolution/photo-9.avif';
import Photo9ImageWEBP from '../../assets/img/evolution/photo-9.webp';
import Photo10Image from '../../assets/img/evolution/photo-10.jpg';
import Photo10ImageAVIF from '../../assets/img/evolution/photo-10.avif';
import Photo10ImageWEBP from '../../assets/img/evolution/photo-10.webp';
import Photo11Image from '../../assets/img/evolution/photo-11.jpg';
import Photo11ImageAVIF from '../../assets/img/evolution/photo-11.avif';
import Photo11ImageWEBP from '../../assets/img/evolution/photo-11.webp';
import Photo12Image from '../../assets/img/evolution/photo-12.jpg';
import Photo12ImageAVIF from '../../assets/img/evolution/photo-12.avif';
import Photo12ImageWEBP from '../../assets/img/evolution/photo-12.webp';
import Photo13Image from '../../assets/img/evolution/photo-13.jpg';
import Photo13ImageAVIF from '../../assets/img/evolution/photo-13.avif';
import Photo14Image from '../../assets/img/evolution/photo-14.jpg';
import Photo14ImageAVIF from '../../assets/img/evolution/photo-14.avif';
import Photo14ImageWEBP from '../../assets/img/evolution/photo-14.webp';
import Photo15Image from '../../assets/img/evolution/photo-15.jpg';
import Photo15ImageAVIF from '../../assets/img/evolution/photo-15.avif';
import Photo15ImageWEBP from '../../assets/img/evolution/photo-15.webp';
import Photo16Image from '../../assets/img/evolution/photo-16.jpg';
import Photo16ImageAVIF from '../../assets/img/evolution/photo-16.avif';

/**
 * `webp: false` nos itens em que o WEBP ficou maior que o próprio JPG, como já
 * acontece na galeria — nesses casos não vale a pena servir o formato extra.
 */
const evolutionPhotos = [
  {
    src: Photo1Image,
    avif: Photo1ImageAVIF,
    webp: Photo1ImageWEBP,
    alt: 'Vista aérea do Mirrage Nautic Club',
  },
  {
    src: Photo2Image,
    avif: Photo2ImageAVIF,
    webp: Photo2ImageWEBP,
    alt: 'Portaria iluminada ao anoitecer',
  },
  {
    src: Photo3Image,
    avif: Photo3ImageAVIF,
    webp: false,
    alt: 'Portaria e paisagismo da entrada',
  },
  {
    src: Photo4Image,
    avif: Photo4ImageAVIF,
    webp: Photo4ImageWEBP,
    alt: 'Fachada em vidro da portaria',
  },
  {
    src: Photo5Image,
    avif: Photo5ImageAVIF,
    webp: false,
    alt: 'Acesso principal do condomínio',
  },
  {
    src: Photo6Image,
    avif: Photo6ImageAVIF,
    webp: false,
    alt: 'Muro de acesso com iluminação cênica',
  },
  {
    src: Photo7Image,
    avif: Photo7ImageAVIF,
    webp: Photo7ImageWEBP,
    alt: 'Reservatório de água do empreendimento',
  },
  {
    src: Photo8Image,
    avif: Photo8ImageAVIF,
    webp: Photo8ImageWEBP,
    alt: 'Paisagismo com palmeiras',
  },
  {
    src: Photo9Image,
    avif: Photo9ImageAVIF,
    webp: Photo9ImageWEBP,
    alt: 'Jardins da entrada em floração',
  },
  {
    src: Photo10Image,
    avif: Photo10ImageAVIF,
    webp: Photo10ImageWEBP,
    alt: 'Via interna ao pôr do sol',
  },
  {
    src: Photo11Image,
    avif: Photo11ImageAVIF,
    webp: Photo11ImageWEBP,
    alt: 'Rua pavimentada com vista para a represa',
  },
  {
    src: Photo12Image,
    avif: Photo12ImageAVIF,
    webp: Photo12ImageWEBP,
    alt: 'Pavimentação concluída das vias internas',
  },
  {
    src: Photo13Image,
    avif: Photo13ImageAVIF,
    webp: false,
    alt: 'Via de acesso asfaltada e sinalizada',
  },
  {
    src: Photo14Image,
    avif: Photo14ImageAVIF,
    webp: Photo14ImageWEBP,
    alt: 'Infraestrutura de energia e iluminação',
  },
  {
    src: Photo15Image,
    avif: Photo15ImageAVIF,
    webp: Photo15ImageWEBP,
    alt: 'Lotes com infraestrutura entregue',
  },
  {
    src: Photo16Image,
    avif: Photo16ImageAVIF,
    webp: false,
    alt: 'Fechamento perimetral do condomínio',
  },
];

export default evolutionPhotos;
